// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"230":"4563f8fd","502":"ed4c3121"}[chunkId] + ".css";
};